export const isInvalidTrip = data => {
  const { webTrackingDetails } = data;
  return webTrackingDetails.length === 0;
};

export const isExpiredTrip = data => {
  const { webTrackingDetails } = data;
  const foundInvalid = webTrackingDetails.find(trip => trip.isExpired === true);
  return !!foundInvalid;
};

export const isSingleTrip = data => {
  const { webTrackingDetails } = data;
  return webTrackingDetails.length === 1;
};

export const isMSD = data => {
  const { webTrackingDetails } = data;
  return webTrackingDetails.length > 1;
};

export const getDynamicAndStaticData = trip => {
  const { dynamicTracking: dynamicData, staticTracking: staticData } = trip;
  return { dynamicData, staticData };
};
